import type { FormsListParams, FormsListView } from "../../types/formList";
import type { FormsListSortBy, FormsListSortDir } from "./formsListPreferences";
import type { FormSourceFilter, FormStatusFilter } from "./formListFilters";

const SORT_FIELDS = new Set(["name", "createdAt", "updatedAt", "answersCount"]);

export function toFormsListSortParam(
  sortBy: FormsListSortBy,
  sortDir: FormsListSortDir,
): string {
  const field = SORT_FIELDS.has(sortBy) ? sortBy : "createdAt";
  return sortDir === "desc" ? `-${field}` : field;
}

export function formsListIsClosedParam(
  status: FormStatusFilter,
): boolean | undefined {
  if (status === "open") return false;
  if (status === "closed") return true;
  return undefined;
}

export function formsListSourceParam(
  source: FormSourceFilter,
): "native" | "yandex" | undefined {
  return source === "native" || source === "yandex" ? source : undefined;
}

export function buildFormsListSearchParams(
  params: FormsListParams,
): URLSearchParams {
  const query = new URLSearchParams({
    page: String(params.page ?? 1),
    count: String(params.count ?? 15),
  });

  const search = params.search?.trim();
  if (search) query.set("search", search);

  if (typeof params.isClosed === "boolean") {
    query.set("isClosed", params.isClosed ? "true" : "false");
  }

  if (params.source === "native" || params.source === "yandex") {
    query.set("source", params.source);
  }

  if (params.view) {
    query.set("view", params.view);
  } else if (params.organisationId != null) {
    query.set("organisationId", String(params.organisationId));
  }

  if (params.sort) query.set("sort", params.sort);

  return query;
}

export function formsListViewFromWorkspace(options: {
  unassigned?: boolean;
  granted?: boolean;
  service?: boolean;
}): FormsListView | undefined {
  if (options.service) return "service";
  if (options.unassigned) return "unassigned";
  if (options.granted) return "granted";
  return undefined;
}
